import mutations from './global.mutations'

const state = {
  showLoadingSpinner: false,
  loadingSpinnerCount: 0,
  showErrorMessage: false,
  showUnauthorizedMessage: false,
  showValidationMessage: false
}

export default {
  namespaced: true,
  state,
  mutations
}
